exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".top___DSFnT {\n  padding: 20px;\n  height: 60px;\n  align-self: flex-start;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n.top___DSFnT img {\n  height: 20px;\n}\n.hed___1WYIR {\n  padding: 20px;\n  text-align: center;\n  margin: 0 auto;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 32px;\n}\n.bgIllustrative___2cCaS {\n  background-color: #f6f5f0;\n}\n.bgJewel8___1fdO6 {\n  background-color: #ebf4f9;\n}\n.bgJewel4___1_oIW {\n  background-color: #f5f9fc;\n}\n.apricotVariant24___3d2Uv {\n  background-color: #fef0eb;\n}\n@keyframes fadeIn___C5H9C {\n  0% {\n    pointer-events: none;\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeOut___3ACxk {\n  0% {\n    pointer-events: none;\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n.fadeIn___C5H9C {\n  animation: fadeIn___C5H9C 0.5s;\n  animation-fill-mode: forwards;\n}\n.fadeOut___3ACxk {\n  animation: fadeOut___3ACxk 0.5s;\n  animation-fill-mode: forwards;\n}\n@keyframes slideInFromRight___8z1Mu {\n  0% {\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n}\n.slideInFromRight___8z1Mu {\n  animation: slideInFromRight___8z1Mu 0.5s;\n}\n.slideOut___1INHD {\n  transform: translateX(-100%);\n  transition: all 0.5s;\n}\n.inner___kM-W1 {\n  min-height: 100vh;\n}\n.absolute___3V_L_ {\n  position: absolute;\n  z-index: 20;\n}\n", ""]);

// exports
exports.locals = {
	"top": "top___DSFnT",
	"hed": "hed___1WYIR",
	"bgIllustrative": "bgIllustrative___2cCaS",
	"bgJewel8": "bgJewel8___1fdO6",
	"bgJewel4": "bgJewel4___1_oIW",
	"apricotVariant24": "apricotVariant24___3d2Uv",
	"fadeIn": "fadeIn___C5H9C",
	"fadeOut": "fadeOut___3ACxk",
	"slideInFromRight": "slideInFromRight___8z1Mu",
	"slideOut": "slideOut___1INHD",
	"inner": "inner___kM-W1",
	"absolute": "absolute___3V_L_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/pages/postOnboard/postOnboardStyles.module.less
// module id = 2072
// module chunks = 71